import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Contact from "@/components/Contact";
import BuildYourOwn from "@/components/BuildYourOwn";
import { usePageMeta } from "@/hooks/usePageMeta";

const HomePage = () => {
  usePageMeta("Vagus Digital | Web design, AI tools & SEO for small businesses");
  return (
    <>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Portfolio />
      <BuildYourOwn />
      <Contact />
    </>
  );
};

export default HomePage;